import { ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseFormComponent } from '../base-form/base-form.component';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent extends BaseFormComponent {
  public passwordVisible = false;

  constructor(translator: TranslateService, changeDetection: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
    super(
      translator,
      changeDetection,
      formBuilder.group({
        cloudId: ['', Validators.required],
        username: ['', Validators.required],
        password: ['', Validators.required],
      })
    );
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
}
